import { Controller } from "@hotwired/stimulus"

/**
 * Vote CTA Controller
 *
 * Shows a sticky floating "Vote Now" button when the main arena banner
 * scrolls out of the viewport, and hides it again when the boundary
 * element (e.g. the "Suggest a Prompt" section) scrolls into view.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["banner", "sticky", "boundary"]

  declare readonly bannerTarget: HTMLElement
  declare readonly stickyTarget: HTMLElement
  declare readonly boundaryTarget: HTMLElement
  declare readonly hasBoundaryTarget: boolean

  private bannerObserver: IntersectionObserver | null = null
  private boundaryObserver: IntersectionObserver | null = null
  private bannerVisible = true
  private boundaryVisible = false

  connect(): void {
    this.bannerObserver = new IntersectionObserver(
      ([entry]) => {
        this.bannerVisible = entry.isIntersecting
        this.update()
      },
      { threshold: 0 }
    )
    this.bannerObserver.observe(this.bannerTarget)

    if (this.hasBoundaryTarget) {
      this.boundaryObserver = new IntersectionObserver(
        ([entry]) => {
          this.boundaryVisible = entry.isIntersecting
          this.update()
        },
        { threshold: 0 }
      )
      this.boundaryObserver.observe(this.boundaryTarget)
    }
  }

  disconnect(): void {
    this.bannerObserver?.disconnect()
    this.boundaryObserver?.disconnect()
  }

  private update(): void {
    const show = !this.bannerVisible && !this.boundaryVisible
    this.stickyTarget.classList.toggle("vote-sticky--visible", show)
  }
}
